export default {
    data() {
        return {
            scrollOffset: 0
        }
    },
    methods: {
        $_updateScrollOffset() {
            this.scrollOffset = window.pageYOffset || document.documentElement.scrollTop;
        }
    },
    mounted() {
        window.addEventListener('scroll', this.$_updateScrollOffset);
    },
    destroyed() {
        window.removeEventListener('scroll', this.$_updateScrollOffset);
    }

}